/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProgressDetailsForAccessValidation extends models.ProgressDetails {
    getFixupPrototypeFunction() { return ProgressDetailsForAccessValidation.fixupPrototype; }

    static newInstance(model: Partial<ProgressDetailsForAccessValidation>): ProgressDetailsForAccessValidation {
        let obj = Object.assign(new ProgressDetailsForAccessValidation(), model);
        ProgressDetailsForAccessValidation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProgressDetailsForAccessValidation>): ProgressDetailsForAccessValidation {
        if (!model) return null;
        return ProgressDetailsForAccessValidation.newInstance(<ProgressDetailsForAccessValidation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProgressDetailsForAccessValidation) {
        if (!obj) return;

        models.ProgressDetailsForAccessValidation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProgressDetailsForAccessValidation): boolean {
        if (models.ProgressDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ProgressDetailsForAccessValidation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.by_context) {
            for (let val of this.by_context) {
                models.AccessValidationByContext.fixupPrototype(val);
            }
        }
    }

    /**
     * Validation results by context
     */
    by_context: Array<models.AccessValidationByContext>;

}
